import { Fragment, useState, useEffect } from "react";
import { setUserEntry, LogOut, updateStationId } from "../../server/Customer";
import { globalFileIcon } from "../../../axiosInstance";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import Accessibility from "../Accessibility";
import CustomerService from "../customerService/CustomerService";
import PrivateAreaList from "../privateArea/PrivateAreaList";
import { FiArrowRight } from "react-icons/fi";
import { getStationsFromPGW, getStationToCustomer } from "../../server/Station";
import HeaderSearch from "./HeaderSearch";
import { updateToken } from "../../server/Customer";
import { setClientView } from "../../server/Category";
import { setStatus } from "../../server/Category";
import ThemeToggle from "../ui/ThemeToggle";

const HeaderConnection = ({
  user,
  stationId,
  role,
  setAllProduct,
  haveGetToken,
  basicHeader,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [openPrivateAreaList, setOpenPrivateAreaList] = useState(false);
  const [userStation, setUserStation] = useState(null);
  const [adminStation, setAdminStation] = useState([]);
  const [displayMode, setDisplayMode] = useState(sessionStorage.getItem("adminDisplayMode") || "allProduct");

  const exit = () => {
    navigate("/");
    dispatch(LogOut());
    haveGetToken();
  };

  const check = async (stationId) => {
    const newStationId = stationId === "678430" ? 4 : stationId;
    await updateToken(newStationId);
    dispatch(updateStationId(stationId));
    if (user) {
      user.StationId = stationId;
    }
  };

  useEffect(() => {
    if (role) {
      getStationsFromPGW()
        .then((stations) => setAdminStation(stations.data))
        .catch((error) => {
          console.error(error);
        });
    } else {
      if (user)
        getStationToCustomer(stationId).then((x) => setUserStation(x.data));
    }
  }, [user, stationId, role]);

  useEffect(() => {
    const saved = sessionStorage.getItem("adminDisplayMode");
    if (saved && role) {
      changeProductDisplay(saved);
    }
  }, [role]);

  const changeProductDisplay = (value) => {
    sessionStorage.setItem("adminDisplayMode", value);
    setDisplayMode(value);
    switch (value) {
      case "allProduct":
        setAllProduct(true);
        dispatch(setClientView(false));
        dispatch(setStatus(true));
        break;
      case "active":
        setAllProduct(false);
        dispatch(setClientView(false));
        dispatch(setStatus(false));
        break;
      case "customer":
        setAllProduct(false);
        dispatch(setClientView(true));
        dispatch(setStatus(false));
        break;
      default:
        console.warn("ערך לא מוכר:", value);
    }
  };

  return (
    <div className="header-connection">
      <div className="back-and-logo">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FiArrowRight />
        </button>
        {!basicHeader && (
          <NavLink to="/" className="site-icon">
            <img
              loading="lazy"
              src={globalFileIcon + "site-icon.svg"}
              alt="site"
            />
          </NavLink>
        )}
      </div>
      {role && !basicHeader && (
        <NavLink to="/admin/users">
          <img src={globalFileIcon + "gear.svg"} alt="menu" />
        </NavLink>
      )}
      {!basicHeader ? (
        <>
          <div className="header-data">
            <li
              className={openMenu ? "data open-menu" : "data"}
              onClick={() => setOpenMenu(true)}
            >
              <img
                loading="lazy"
                src={globalFileIcon + "customer-service.svg"}
                alt="customer-service"
              />
              <a
                href="/"
                className="customer-service"
                onClick={(e) => e.preventDefault()}
              >
                שירות לקוחות
              </a>
            </li>
            {openMenu ? (
              <div className="customer-service-menu">
                <CustomerService setOpenMenu={setOpenMenu} />
              </div>
            ) : null}
            <Accessibility />
          </div>
          <HeaderSearch />
        </>
      ) : (
        <h2>פאנל הניהול</h2>
      )}

      <div className="login-or-sign-in flex flex-wrap items-center gap-2">
        <ThemeToggle />
        {!user || localStorage.getItem("userRole").includes("guest") ? (
          <div>
            <button
              className="login ui-auth-btn"
              onClick={() => dispatch(setUserEntry([true, "login"]))}
            >
              כניסה
            </button>
            <button
              className="sign-in ui-auth-btn ui-auth-btn--primary"
              onClick={() => dispatch(setUserEntry([true, "signIn"]))}
            >
              הרשמה
            </button>
          </div>
        ) : (
          <Fragment>
            <div>
              {" "}
              {role && !basicHeader && (
                <button className="btn-to-private-area">
                  <select
                    className="custom-select"
                    value={displayMode}
                    onChange={(e) => changeProductDisplay(e.target.value)}
                  >
                    <option value="allProduct">תצוגת כל המוצרים</option>
                    <option value="active">תצוגת פעילים</option>
                    <option value="customer">תצוגת לקוח</option>
                  </select>
                </button>
              )}
              {role ? (
                <button className="btn-to-private-area station-user">
                  מנהל /{" "}
                  <select
                    value={stationId || ""}
                    onChange={(e) => check(e.target.value)}
                    className="custom-select"
                  >
                    {adminStation.map((station) => (
                      <option key={station.id} value={station.id}>
                        {station.name}
                      </option>
                    ))}
                  </select>
                </button>
              ) : (
                <button className="btn-to-private-area station-user">
                  <span className="custom-customer">
                    תחנת {userStation?.name}
                  </span>
                </button>
              )}
              {!role && (
                <Fragment>
                  <button
                    onClick={() => setOpenPrivateAreaList(true)}
                    className="btn-to-private-area"
                  >
                    <span>
                      לאזור האישי של {user.firstName} {user.lastName}
                    </span>
                  </button>
                  {openPrivateAreaList && (
                    <div className="private-area-list-menu">
                      <PrivateAreaList
                        setOpenPrivateAreaList={setOpenPrivateAreaList}
                      />
                    </div>
                  )}
                </Fragment>
              )}
              <button onClick={() => exit()} className="exit">
                <span>יציאה</span>
              </button>
              {role && (
                <>
                  {basicHeader ? (
                    <NavLink to="/">
                      <img
                        src={globalFileIcon + "close-menu.svg"}
                        alt="close"
                      />
                    </NavLink>
                  ) : null}
                </>
              )}
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default HeaderConnection;
